import { render, staticRenderFns } from "./edit_card.vue?vue&type=template&id=1d79358b&scoped=true"
import script from "./edit_card.vue?vue&type=script&lang=js"
export * from "./edit_card.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/consumables.css?vue&type=style&index=0&id=1d79358b&prod&scoped=true&lang=css&external"
import style1 from "../../assets/css/doctor-detail.css?vue&type=style&index=1&id=1d79358b&prod&scoped=true&lang=css&external"
import style2 from "../../assets/css/case_management_add_case.css?vue&type=style&index=2&id=1d79358b&prod&scoped=true&lang=css&external"
import style3 from "./edit_card.vue?vue&type=style&index=3&id=1d79358b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d79358b",
  null
  
)

export default component.exports